import Vue from 'vue';
import * as C from '../constants';

export default {

  /**
   * Sets session info in state.
   *
   * @param state
   * @param payload
   */
  [C.APP_SESSION_INFO_SET](state, { user, brands, products, suppliers }) {
    Vue.set(state, 'auth', {
      ...state.auth,
      user,
      brands,
      products,
      suppliers,
      session: true,
    });
  },

  /**
   * @param state
   */
  [C.APP_DOMAINS_PENDING](state) {
    Vue.set(state, 'domains', {
      loading: true,
      error: null,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.APP_DOMAINS_SUCCESS](state, payload) {
    Vue.set(state, 'domains', {
      loading: false,
      error: null,
      items: payload,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.APP_DOMAINS_PENDING](state, payload) {
    Vue.set(state, 'domains', {
      loading: false,
      error: payload,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.APP_LOADING_PENDING](state, payload) {
    Vue.set(state, 'loading', {
      ...state.loading,
      state: true,
      steps: {
        total: payload.total,
        current: payload.current,
      },
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.APP_LOADING_SET_CURRENT_STEP](state, payload) {
    Vue.set(state.loading, 'steps', {
      ...state.loading.steps,
      current: payload,
      error: false,
    });
  },

  /**
   * @param state
   */
  [C.APP_LOADING_SUCCESS](state) {
    Vue.set(state, 'loading', {
      ...state.loading,
      state: false,
      steps: {
        total: 0,
        current: 0,
      },
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.APP_LOADING_ERROR](state) {
    Vue.set(state.loading, 'steps', {
      ...state.loading.steps,
      state: false,
      steps: {
        total: 0,
        current: 0,
      },
      error: true,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/app/mutations.js